import React, { memo } from 'react';
import HBBaseFormField, {
    HBBaseFormFieldProps,
    splitFieldProps
} from '../HBBaseFormField/HBBaseFormField';
import HBPhoneInput from '../HBPhoneInput/HBPhoneInput';
import { HBPhoneInputProps } from '../HBPhoneInput/HBPhoneInput.types';
import { TControlSize } from '../../tokens/types';

export interface HBPhoneInputFieldProps
    extends HBBaseFormFieldProps,
        Omit<HBPhoneInputProps, 'size' | 'width'> {
    /** Controls the height and font size of the phone input. Defaults to `'sm'`. */
    size?: TControlSize;
}

const HBPhoneInputField = ({
    size = 'sm',
    ...props
}: HBPhoneInputFieldProps) => {
    const { fieldProps, inputProps } = splitFieldProps(props);

    return (
        <HBBaseFormField {...fieldProps} size={size}>
            <HBPhoneInput {...inputProps} size={size} />
        </HBBaseFormField>
    );
};

export default memo(HBPhoneInputField);
